import { map200Response } from './map200Response';
import { map400Response } from './map400Response';

export const mappers = {
  200: map200Response,
  400: map400Response,
};
